import { Component, Input } from "@angular/core";

export enum EStatusPannel {
    success = "success",
    error = "error",
    warning = "warning",
    inProgress = "in-progress",
    used = "used",
}

@Component({
    selector: 'status-pannel',
    template: `
        <div class="pannel-container" [ngClass]="status" [class.fixed-width]="fixedWidth">
            <p class="pannel-text">{{ text }}</p>
        </div>
    `,
    styleUrls: ['./status-pannel.component.scss'],
})
export class StatusPannelComponent {
    @Input()
    public status: EStatusPannel;
    @Input()
    public text: string;
    @Input()
    public fixedWidth: boolean;
}